import {Divider} from "@material-ui/core";
import {Values} from "Tools/Values";
import React from "react";
import {AppInfoContainer, DetailTitle} from "../styles";
import {FileCopy} from "@material-ui/icons";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";
import {TokenExpires, TokenValue} from "./styles";

interface IProps {
    token: string;
    expiresAt: string;
}

export const InternalAppDetailsToken = ({token, expiresAt}: IProps) => (
    <AppInfoContainer>
        <DetailTitle>
            {Values.getLocalizationValue('token')}
        </DetailTitle>

        <Divider/>

        <div style={{display: 'flex'}}>
            <TokenValue>{token}</TokenValue>

            <RoundButton
                icon={<FileCopy/>}
                tooltipTitle={Values.getLocalizationValue('copy')}
                onClick={() => navigator.clipboard.writeText(token)}
                color="gray"
            />
        </div>

        <TokenExpires>
            {`${Values.getLocalizationValue('expiresAt')} ${expiresAt.substring(0, 10)}`}
        </TokenExpires>
    </AppInfoContainer>
)
